module.exports = __webpack_public_path__ + "static/media/banner-new-bg1.7b05750a.jpg";